import { useColorModeValue } from '@chakra-ui/react'
import { BarDatum, ResponsiveBar } from '@nivo/bar'
import { themeDark, themeLight } from 'theme/charts'
import { defaultColors } from 'theme/charts/default'

interface Props {
    data: BarDatum[]
    tooltip?: (args1: any) => React.ReactNode
    customColors?: string[]
    customProps?: any
    colorBy?: (args1: string) => string
}

const VerticalBars = ({ data, tooltip, customColors, customProps, colorBy }: Props) => {
    const theme = useColorModeValue(themeLight, themeDark)

    return (
        <ResponsiveBar
            data={data}
            indexBy="label"
            keys={[
                'value'
            ]}
            theme={theme}
            tooltip={(values: any) => tooltip ? tooltip(values) : null}
            colors={customColors || defaultColors}
            colorBy={({indexValue}: any) =>  colorBy ? colorBy(indexValue) : null}
            axisBottom={{
                tickSize: 5,
                tickPadding: 5,
                tickRotation: 0,
                legendPosition: "middle",
                legendOffset: 32
            }}
            margin={{ bottom: 25 }}
            {...customProps}
        />
    )
}

export default VerticalBars